import useLayoutEffect from '../utils/useIsomorphicLayoutEffect';
export function useResizeObserver(callback) {
  useLayoutEffect(function () {
    var observer = new window.ResizeObserver(function () {
      return callback();
    });
    observer.observe(document.documentElement);
    return function () {
      observer.disconnect();
    };
  }, [callback]);
}